import axios from "axios";

export const API_BASE =
  process.env.REACT_APP_API_BASE || "https://compass-app-13.emergent.host";

// Brand compass artwork (user-provided), reused across auth hero, loader, and logo.
export const COMPASS_IMG =
  "https://customer-assets-m6fa6gv7.emergentagent.net/job_compass-connect-7/artifacts/bd1y161i_00_app_icon_512x512.png";

export const TOKEN_KEY = "compass_token";

const api = axios.create({ baseURL: `${API_BASE}/api` });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem(TOKEN_KEY);
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export default api;

export const todayKey = () => {
  const d = new Date();
  return `${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
};

const MONTHS = ["January","February","March","April","May","June","July","August","September","October","November","December"];

export const prettyDate = (mmdd) => {
  if (!mmdd) return "";
  const [mm, dd] = mmdd.split("-");
  const idx = parseInt(mm, 10) - 1;
  if (idx < 0 || idx > 11) return mmdd;
  return `${MONTHS[idx]} ${parseInt(dd, 10)}`;
};

export const monthName = (m) => MONTHS[(m - 1 + 12) % 12];

export const timeAgo = (iso) => {
  if (!iso) return "";
  const then = new Date(iso).getTime();
  const diff = Math.max(0, Math.floor((Date.now() - then) / 1000));
  if (diff < 60) return "just now";
  if (diff < 3600) return `${Math.floor(diff / 60)}m ago`;
  if (diff < 86400) return `${Math.floor(diff / 3600)}h ago`;
  if (diff < 604800) return `${Math.floor(diff / 86400)}d ago`;
  return new Date(iso).toLocaleDateString();
};

// Coerce any Axios/FastAPI error into a safe display string.
// FastAPI 422 returns `detail` as an array of Pydantic error objects, which
// crashes React if rendered directly. Always run errors through this.
export const errMsg = (e, fallback = "Something went wrong") => {
  const d = e?.response?.data?.detail;
  if (Array.isArray(d)) return d.map((x) => x?.msg || String(x)).join(", ");
  if (typeof d === "string") return d;
  if (d && typeof d === "object") return d.msg || fallback;
  return e?.message || fallback;
};

export const fileToBase64 = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result);
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });
